export const PROFILE_EMPTY_STATE = {
  personalInfo: {
    ctaTitle: 'Add Personal Information',
    body: 'You have no personal information on file.',
  },
  businessInfo: {
    ctaTitle: 'Add Business Information',
    body: 'You have no business information on file.',
  },
  companionNumber: {
    ctaTitle: 'Add Companion Number',
    body: "Add a companion's Caesars Rewards account. No matter who plays, everyone wins.",
  },
};

export const NORTH_AMERICA_CODE = '1';

export interface PersonalInfo {
  email: string | undefined;
  homephone: string | undefined;
  homeaddress1: string | undefined;
  homeaddress2: string | undefined;
  mobilenumber: string | undefined;
  homestate: string | undefined;
  homecountry: string | undefined;
  countrycode: string | undefined;
  homezip: string | undefined;
  homecity: string | undefined;
}

export interface BusinessInfo {
  businessphone: string | undefined;
  businessaddress1: string | undefined;
  businessaddress2: string | undefined;
  businesscity: string | undefined;
  businesszip: string | undefined;
  businessstate: string | undefined;
  businesscountry: string | undefined;
}
